export default __webpack_public_path__ + "static/media/saveOutlineColorIcon.0b47a325.svg";